import { AllRows, Columns, ReportData } from '../result.interface';

export function getFileExportCombustible(ctx: any, vrs: number): any {

    var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config:Columns[] = [];

    var nom_inf = "REPORTE DE COMBUSTIBLE GENERAL";

    var allRows: AllRows[] = [
        {
          cells: [
            { value: nom_inf, ...ctx.headerCellConfig, colSpan: 3 }
          ],
          height: ctx.headerRowsHeight,
        },
        ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
    ];

    var cc = 0;

    var velocidad_cell_ch_width = "Velocidad".length;
    var nivel_comb_cell_ch_width = "combustible".length;
    var consumo_litros_cell_ch_width = "Combustible litros".length;
    var consumo_hrfc_cell_ch_width = "Consumo HRFC".length;
    var combustible_restante_cell_ch_width = "Restante (galones)".length;
    var contacto_motor_cell_ch_width = "Contacto".length;
    var odometro_cell_ch_width = "Odometro".length;
    var ubicacion_cell_ch_width = "Ubicación".length;
    // var mensaje_alerta_cell_ch_width = "de Alerta".length;
    // var combustible_alerta_cell_ch_width = "Alerta galones".length;
    var can_rpm_cell_ch_width = "can_rpm".length;
    var altitud_cell_ch_width = "Altitud".length;

    var table_width = 1 + (ctx.chkDateHour? 2:1) + 10;
    var vehiculo_width = (ctx.chkDateHour? 7:5);

    ctx.sortedData.forEach((table_data: any) => {
      if(table_data[1].length > 0){
        column_config = [];

        bol_datos_ex = true;

        var nom_vehi = table_data[0][1];


        /* Table Header */

        var rows: AllRows[] = [
          {
            cells: [
              { value: nom_inf, ...ctx.headerCellConfig, colSpan: table_width }
            ],
            height: ctx.headerRowsHeight,
          },
          ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
          {
            cells: [
              { value: "VEHÍCULO", ...ctx.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
              { value: "PERIODO",  ...ctx.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
            ],
            height: ctx.subHeaderHeight
          },
          {
            cells: [
              { value: table_data[0][1], ...ctx.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              { value: ctx.period,  ...ctx.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width },
            ],
            height: ctx.subHeaderContentHeight
          },
          ...ctx.generateEmptyRowsForRowSpan(ctx.subHeaderContentRowSpan, ctx.subHeaderContentHeight),
        ];

        /* Table Body */

        var cellsCampos = [];

        //----------- CABECERA ------------
        cellsCampos.push({ value: "Ítem", ...ctx.colHeaderConfig });

        cellsCampos.push({ value: "Fecha", ...ctx.colHeaderConfig });
        if (ctx.chkDateHour) {
          cellsCampos.push({ value: "Hora", ...ctx.colHeaderConfig });
        }

        cellsCampos.push({ value: "Vel. CAN (km/h)", ...ctx.colHeaderConfig, wrap: true });
        cellsCampos.push({ value: "Nivel de Combustible (%)", ...ctx.colHeaderConfig, wrap: true });
        cellsCampos.push({ value: "Consumo de Combustible (litros)", ...ctx.colHeaderConfig, wrap: true });
        cellsCampos.push({ value: "Consumo HRFC (litros)", ...ctx.colHeaderConfig, wrap: true });
        cellsCampos.push({ value: "Combustible Restante (galones)", ...ctx.colHeaderConfig, wrap: true });
        cellsCampos.push({ value: "Contacto de Motor", ...ctx.colHeaderConfig, wrap: true });

        if(ctx.chkOdomV){
          cellsCampos.push({ value: "Odómetro Virtual", ...ctx.colHeaderConfig, wrap: true });
        } else {
          cellsCampos.push({ value: "Odómetro", ...ctx.colHeaderConfig});
        }

        cellsCampos.push({ value: "Ubicación", ...ctx.colHeaderConfig});
        // cellsCampos.push({ value: "Mensaje de Alerta", ...ctx.colHeaderConfig, wrap: true});
        // cellsCampos.push({ value: "Combustible Alerta (galones)", ...ctx.colHeaderConfig, wrap: true});
        cellsCampos.push({ value: "can_rpm", ...ctx.colHeaderConfig});
        cellsCampos.push({ value: "Altitud", ...ctx.colHeaderConfig});

        rows.push({
          cells: cellsCampos,
          height: ctx.colsHeaderHeightTwoLine
        });

        //----------- CONTENIDO / FILAS ------------
        table_data[1].forEach((item: { latitud: number; longitud: number; can_speed: any; fuel_level: any; fuel_used: any; can_HRFC: any; combusrestante: any; di4: any; can_dist: any; virtual_odom:any; alerta: any; combustiblealerta: any; can_rpm: any; altitude: any; fecha: any; }, index: number) => {

          var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";
          var cellsCuerpo = [];

          velocidad_cell_ch_width = Math.max(velocidad_cell_ch_width, (item.can_speed??'').toString().length);
          nivel_comb_cell_ch_width = Math.max(nivel_comb_cell_ch_width, (item.fuel_level??'').toString().length);
          consumo_litros_cell_ch_width = Math.max(consumo_litros_cell_ch_width, (item.fuel_level??'').toString().length);
          consumo_hrfc_cell_ch_width = Math.max(consumo_hrfc_cell_ch_width, (item.can_HRFC??'').toString().length);
          combustible_restante_cell_ch_width = Math.max(combustible_restante_cell_ch_width, (item.combusrestante??'').toString().length);
          contacto_motor_cell_ch_width = Math.max(contacto_motor_cell_ch_width, ((item.di4)).toString().length);
          odometro_cell_ch_width = Math.max(odometro_cell_ch_width, (item.can_dist??'').toString().length);
          ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);
          // mensaje_alerta_cell_ch_width = Math.max(mensaje_alerta_cell_ch_width, (item.alerta??'').toString().length);
          // combustible_alerta_cell_ch_width = Math.max(combustible_alerta_cell_ch_width, (item.combustiblealerta??'').toString().length);
          can_rpm_cell_ch_width = Math.max(can_rpm_cell_ch_width, (item.can_rpm??'').toString().length);
          altitud_cell_ch_width = Math.max(altitud_cell_ch_width, (item.altitude??'').toString().length);

          cellsCuerpo.push({ value: index + 1, ...ctx.bodyRowsConfig });

          if (ctx.chkDateHour) {
            cellsCuerpo.push({ value: ctx.isChe(item.fecha), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
            cellsCuerpo.push({ value: ctx.isChs(item.fecha), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
          } else {
            cellsCuerpo.push({ value: ctx.isChe(item.fecha), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
          }
          cellsCuerpo.push({ value: item.can_speed, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.fuel_level, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.fuel_used, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.can_HRFC, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.combusrestante, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.di4, ...ctx.bodyRowsConfig });

          if(ctx.chkOdomV){
            cellsCuerpo.push({ value: item.virtual_odom, ...ctx.bodyRowsConfig });
          } else {
            cellsCuerpo.push({ value: item.can_dist, ...ctx.bodyRowsConfig });
          }
  
          // cellsCuerpo.push({ value: ubicacion, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...ctx.bodyRowsConfig });
          // cellsCuerpo.push({ value: item.alerta, ...ctx.bodyRowsConfig });
          // cellsCuerpo.push({ value: item.combustiblealerta, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.can_rpm, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.altitude, ...ctx.bodyRowsConfig });

          rows.push({
            cells:cellsCuerpo,
            height: ctx.bodyRowsHeight,
          });
        });

        rows.push(
          ...ctx.spaceBetweenTables,
          {
            cells: [
              { value: "TOTAL DE DISTANCIA RECORRIDA : ", ...ctx.overviewLeftConfig, colSpan: 4 },
              { value: table_data[2][0], ...ctx.overviewRightConfig, colSpan: 2 }
            ],
            height: ctx.overviewRowsHeight
          },
          {
            cells: [
              { value: "TOTAL DE COMBUSTIBLE CONSUMIDO : ", ...ctx.overviewLeftConfig, colSpan: 4 },
              { value: table_data[2][1], ...ctx.overviewRightConfig, colSpan: 2 }
            ],
            height: ctx.overviewRowsHeight
          },
          {
            cells: [
              { value: "TOTAL DE COMBUSTIBLE HRFC CONSUMIDO : ", ...ctx.overviewLeftConfig, colSpan: 4 },
              { value: table_data[2][2], ...ctx.overviewRightConfig, colSpan: 2 }
            ],
            height: ctx.overviewRowsHeight
          },
          {
            cells: [
              { value: "RENDIMIENTO POR GALÓN : ", ...ctx.overviewLeftConfig, colSpan: 4 },
              { value: table_data[2][3], ...ctx.overviewRightConfig, colSpan: 2 }
            ],
            height: ctx.overviewRowsHeight
          }
        );

        // //********************************************* excel version 2 *********************************
        if ( vrs == 2 ) {
          rows.splice(0, ctx.headerRowSpan);
          rows.push(...ctx.spaceBetweenTables);
          allRows = allRows.concat(rows);
        }

        // //********************************************* excel version 1 *********************************

        /* Ancho de Columnas */

        if( vrs == 1 ){
          column_config = [
            { width: ctx.w_item },
          ];
          if(ctx.chkDateHour){
            column_config.push(
              { width: ctx.w_date },
              { width: ctx.w_hour },
            )
          } else {
            column_config.push(
              { width: ctx.w_date_and_hour },
            )
          }
          column_config.push(
            { width: ctx.calculateColWidth(velocidad_cell_ch_width) },
            { width: ctx.calculateColWidth(nivel_comb_cell_ch_width) },
            { width: ctx.calculateColWidth(consumo_litros_cell_ch_width) },
            { width: ctx.calculateColWidth(consumo_hrfc_cell_ch_width) },
            { width: ctx.calculateColWidth(combustible_restante_cell_ch_width) },
            { width: ctx.calculateColWidth(contacto_motor_cell_ch_width) },
            { width: ctx.calculateColWidth(odometro_cell_ch_width) },
            { width: ctx.calculateColWidth(ubicacion_cell_ch_width) },
            // { width: ctx.calculateColWidth(mensaje_alerta_cell_ch_width) },
            // { width: ctx.calculateColWidth(combustible_alerta_cell_ch_width) },
            { width: ctx.calculateColWidth(can_rpm_cell_ch_width) },
            { width: ctx.calculateColWidth(altitud_cell_ch_width) },
          );

          /* Fin Ancho de Columnas */

          exportFileEx.push({
            freezePane: {
                rowSplit: ctx.headerRowSpan + ctx.subHeaderContentRowSpan + 2
              },
            columns: column_config,
            title: nom_vehi,
            rows: rows
          });

          velocidad_cell_ch_width = "Velocidad".length;
          nivel_comb_cell_ch_width = "combustible".length;
          consumo_litros_cell_ch_width = "Combustible litros".length;
          consumo_hrfc_cell_ch_width = "Consumo HRFC".length;
          combustible_restante_cell_ch_width = "Restante galones".length;
          contacto_motor_cell_ch_width = "Contacto".length;
          odometro_cell_ch_width = "Odometro".length;
          ubicacion_cell_ch_width = "Ubicación".length;
          // mensaje_alerta_cell_ch_width = "de Alerta".length;
          // combustible_alerta_cell_ch_width = "Alerta galones".length;
          can_rpm_cell_ch_width = "can_rpm".length;
          altitud_cell_ch_width = "Altitud".length;
        }

      } // if si hay datos del vehiculo
    });

    //NOTA: width * 1.28 (aprox) = Ancho de columna en excel

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;

      column_config = [
        { width: ctx.w_item },
      ];
      if(ctx.chkDateHour){
        column_config.push(
          { width: ctx.w_date },
          { width: ctx.w_hour },
        )
      } else {
        column_config.push(
          { width: ctx.w_date_and_hour },
        )
      }
      column_config.push(
        { width: ctx.calculateColWidth(velocidad_cell_ch_width) },
        { width: ctx.calculateColWidth(nivel_comb_cell_ch_width) },
        { width: ctx.calculateColWidth(consumo_litros_cell_ch_width) },
        { width: ctx.calculateColWidth(consumo_hrfc_cell_ch_width) },
        { width: ctx.calculateColWidth(combustible_restante_cell_ch_width) },
        { width: ctx.calculateColWidth(contacto_motor_cell_ch_width) },
        { width: ctx.calculateColWidth(odometro_cell_ch_width) },
        { width: ctx.calculateColWidth(ubicacion_cell_ch_width) },
        // { width: ctx.calculateColWidth(mensaje_alerta_cell_ch_width) },
        // { width: ctx.calculateColWidth(combustible_alerta_cell_ch_width) },
        { width: ctx.calculateColWidth(can_rpm_cell_ch_width) },
        { width: ctx.calculateColWidth(altitud_cell_ch_width) },
      );

      exportFileEx.push({
        freezePane: {
            rowSplit: ctx.headerRowSpan
          },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });

    }
    //********************************************* excel version 2 *********************************

    console.log("===>exportFileEx getFileExportCombustible", exportFileEx);  

    if (bol_datos_ex) {
        return exportFileEx;
    } else {
        return [];
    }
    
  }